import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StateService } from 'src/app/services/state.service';
import { InputFieldComponent } from 'src/app/shared-extra/components/input-field/input-field.component';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { TooltipDirective } from 'src/app/shared/directives/tooltip.directive';
import { SortByPipe } from 'src/app/shared/pipes/sort-by.pipe';
import { TogglerComponent } from '../../shared-extra/components/toggler/toggler.component';
import { SvgComponent } from '../../shared/components/svg/svg.component';

@Component({
  selector: 'app-server-timing',
  standalone: true,
  templateUrl: './server-timing.component.html',
  styleUrls: ['./server-timing.component.scss'],
  imports: [
    CommonModule,
    TogglerComponent,
    TooltipDirective,
    SortByPipe,
    SvgComponent,
    ButtonDirective,
    FormsModule,
    ReactiveFormsModule,
    InputFieldComponent,
  ],
})
export class ServerTimingComponent {
  public state = inject(StateService);
  openStates: { [key: string]: boolean } = {};
  search = '';
  form = new FormGroup({
    search: new FormControl(''),
  });

  constructor() {
    this.form.valueChanges.subscribe(value => {
      this.search = value.search;
    });
  }

  filterBySearch = (items: typeof this.state.serverTimingData) => {
    if (this.search.startsWith('method:')) {
      const method = this.search.split(':')[1].trim().toUpperCase();
      return items.filter(item => item.method.startsWith(method));
    }

    return items.filter(item => {
      return (
        item.url.toLowerCase().includes(this.search) ||
        item.rows.some(row => row.description.toLowerCase().includes(this.search))
      );
    });
  };

  addMark() {
    const latest = this.state.serverTimingData[this.state.serverTimingData.length - 1];
    this.state.serverTimingData.push(<(typeof this.state.serverTimingData)[number]>{
      responseTime: latest.responseTime + 1,
      url: 'mark',
    });
  }

  cleanUrl(url: string) {
    return url
      .replace(/.*\/v1\//, '/')
      .replace(/&r=.*/, '')
      .replace(/\?r=.*/, '');
  }
}
